import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { authUtils } from '@/utils/auth';

interface PublicRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export default function PublicRoute({
  children,
  redirectTo = '/dashboard',
}: PublicRouteProps) {
  const isAuthenticated = authUtils.isAuthenticated();

  if (isAuthenticated) {
    // User is already logged in, redirect to the main page
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
